// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/websocketnotify/v1/websocketnotify.proto" (package "c1.api.websocketnotify.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { A2UIEnvelope } from "../../a2ui/v1/a2ui";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export interface ChangedRef {
    /**
     * @generated from protobuf field: c1.api.websocketnotify.v1.ChangedRefEventType event_type = 1
     */
    eventType: ChangedRefEventType;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 2
     */
    lastUpdatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Any changed = 3
     */
    changed?: Any;
}
/**
 * AuthMessage - proto-based, extensible for future auth mechanisms (e.g., DPoP)
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export interface AuthMessage {
    /**
     * @generated from protobuf field: string access_token = 1
     */
    accessToken: string; // Reserved for future: DPoP proof, nonces, etc.
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export interface RefSubscription {
    /**
     * @generated from protobuf field: string ref_type = 1
     */
    refType: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any refs = 2
     */
    refs: Any[];
    /**
     * @generated from protobuf field: bool watch_inserts = 3
     */
    watchInserts: boolean;
}
/**
 * @generated from protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export interface SubscribeMessage {
    /**
     * @generated from protobuf field: string access_token = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.websocketnotify.v1.RefSubscription ref_subscriptions = 2
     */
    refSubscriptions: RefSubscription[];
}
/**
 * JoinConversationMessage - Client requests to receive messages for a conversation
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.JoinConversationMessage
 */
export interface JoinConversationMessage {
    /**
     * @generated from protobuf field: string access_token = 1
     */
    accessToken: string;
    /**
     * @generated from protobuf field: string conversation_id = 2
     */
    conversationId: string;
}
/**
 * LeaveConversationMessage - Client stops receiving messages for a conversation
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.LeaveConversationMessage
 */
export interface LeaveConversationMessage {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
}
/**
 * ChatMessage - Server sends chat message to client
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ChatMessage
 */
export interface ChatMessage {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * @generated from protobuf field: bytes payload = 2
     */
    payload: Uint8Array; // Binary-encoded UIMessage from c1.api.conversations.v1
}
/**
 * AuthAck - Server confirms successful authentication
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.AuthAck
 */
export interface AuthAck {
}
/**
 * ErrorMessage - Server reports errors
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ErrorMessage
 */
export interface ErrorMessage {
    /**
     * @generated from protobuf field: string code = 1
     */
    code: string;
    /**
     * @generated from protobuf field: string message = 2
     */
    message: string;
}
/**
 * ClientMessage - Client-to-server envelope with all operations
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export interface ClientMessage {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "auth";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.AuthMessage auth = 1
         */
        auth: AuthMessage;
    } | {
        oneofKind: "subscribe";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.SubscribeMessage subscribe = 2
         */
        subscribe: SubscribeMessage;
    } | {
        oneofKind: "joinConversation";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.JoinConversationMessage join_conversation = 3
         */
        joinConversation: JoinConversationMessage;
    } | {
        oneofKind: "leaveConversation";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.LeaveConversationMessage leave_conversation = 4
         */
        leaveConversation: LeaveConversationMessage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * ServerMessage - Typed server-to-client envelope for all responses
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.ServerMessage
 */
export interface ServerMessage {
    /**
     * @generated from protobuf oneof: message
     */
    message: {
        oneofKind: "changedRef";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ChangedRef changed_ref = 1
         */
        changedRef: ChangedRef;
    } | {
        oneofKind: "chatMessage";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ChatMessage chat_message = 2
         */
        chatMessage: ChatMessage;
    } | {
        oneofKind: "authAck";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.AuthAck auth_ack = 3
         */
        authAck: AuthAck;
    } | {
        oneofKind: "error";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.ErrorMessage error = 4
         */
        error: ErrorMessage;
    } | {
        oneofKind: "a2UiSurface";
        /**
         * @generated from protobuf field: c1.api.websocketnotify.v1.A2UISurfaceMessage a2ui_surface = 5
         */
        a2UiSurface: A2UISurfaceMessage;
    } | {
        oneofKind: undefined;
    };
}
/**
 * A2UISurfaceMessage wraps A2UI envelope for WebSocket delivery
 *
 * @generated from protobuf message c1.api.websocketnotify.v1.A2UISurfaceMessage
 */
export interface A2UISurfaceMessage {
    /**
     * @generated from protobuf field: string conversation_id = 1
     */
    conversationId: string;
    /**
     * @generated from protobuf field: c1.api.a2ui.v1.A2UIEnvelope envelope = 2
     */
    envelope?: A2UIEnvelope;
}
/**
 * @generated from protobuf enum c1.api.websocketnotify.v1.ChangedRefEventType
 */
export enum ChangedRefEventType {
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_INSERT = 1;
     */
    INSERT = 1,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_MODIFY = 2;
     */
    MODIFY = 2,
    /**
     * @generated from protobuf enum value: CHANGED_REF_EVENT_TYPE_REMOVE = 3;
     */
    REMOVE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class ChangedRef$Type extends MessageType<ChangedRef> {
    constructor() {
        super("c1.api.websocketnotify.v1.ChangedRef", [
            { no: 1, name: "event_type", kind: "enum", T: () => ["c1.api.websocketnotify.v1.ChangedRefEventType", ChangedRefEventType, "CHANGED_REF_EVENT_TYPE_"] },
            { no: 2, name: "last_updated_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "changed", kind: "message", T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ChangedRef>): ChangedRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.eventType = 0;
        if (value !== undefined)
            reflectionMergePartial<ChangedRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChangedRef): ChangedRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.websocketnotify.v1.ChangedRefEventType event_type */ 1:
                    message.eventType = reader.int32();
                    break;
                case /* google.protobuf.Timestamp last_updated_at */ 2:
                    message.lastUpdatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.lastUpdatedAt);
                    break;
                case /* google.protobuf.Any changed */ 3:
                    message.changed = Any.internalBinaryRead(reader, reader.uint32(), options, message.changed);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChangedRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.websocketnotify.v1.ChangedRefEventType event_type = 1; */
        if (message.eventType !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventType);
        /* google.protobuf.Timestamp last_updated_at = 2; */
        if (message.lastUpdatedAt)
            Timestamp.internalBinaryWrite(message.lastUpdatedAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Any changed = 3; */
        if (message.changed)
            Any.internalBinaryWrite(message.changed, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ChangedRef
 */
export const ChangedRef = new ChangedRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthMessage$Type extends MessageType<AuthMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.AuthMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AuthMessage>): AuthMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        if (value !== undefined)
            reflectionMergePartial<AuthMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthMessage): AuthMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.AuthMessage
 */
export const AuthMessage = new AuthMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RefSubscription$Type extends MessageType<RefSubscription> {
    constructor() {
        super("c1.api.websocketnotify.v1.RefSubscription", [
            { no: 1, name: "ref_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "watch_inserts", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<RefSubscription>): RefSubscription {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refType = "";
        message.refs = [];
        message.watchInserts = false;
        if (value !== undefined)
            reflectionMergePartial<RefSubscription>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RefSubscription): RefSubscription {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string ref_type */ 1:
                    message.refType = reader.string();
                    break;
                case /* repeated google.protobuf.Any refs */ 2:
                    message.refs.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool watch_inserts */ 3:
                    message.watchInserts = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RefSubscription, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string ref_type = 1; */
        if (message.refType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.refType);
        /* repeated google.protobuf.Any refs = 2; */
        for (let i = 0; i < message.refs.length; i++)
            Any.internalBinaryWrite(message.refs[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* bool watch_inserts = 3; */
        if (message.watchInserts !== false)
            writer.tag(3, WireType.Varint).bool(message.watchInserts);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.RefSubscription
 */
export const RefSubscription = new RefSubscription$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SubscribeMessage$Type extends MessageType<SubscribeMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.SubscribeMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ref_subscriptions", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RefSubscription }
        ]);
    }
    create(value?: PartialMessage<SubscribeMessage>): SubscribeMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.refSubscriptions = [];
        if (value !== undefined)
            reflectionMergePartial<SubscribeMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SubscribeMessage): SubscribeMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* repeated c1.api.websocketnotify.v1.RefSubscription ref_subscriptions */ 2:
                    message.refSubscriptions.push(RefSubscription.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SubscribeMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* repeated c1.api.websocketnotify.v1.RefSubscription ref_subscriptions = 2; */
        for (let i = 0; i < message.refSubscriptions.length; i++)
            RefSubscription.internalBinaryWrite(message.refSubscriptions[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.SubscribeMessage
 */
export const SubscribeMessage = new SubscribeMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JoinConversationMessage$Type extends MessageType<JoinConversationMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.JoinConversationMessage", [
            { no: 1, name: "access_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<JoinConversationMessage>): JoinConversationMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accessToken = "";
        message.conversationId = "";
        if (value !== undefined)
            reflectionMergePartial<JoinConversationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JoinConversationMessage): JoinConversationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string access_token */ 1:
                    message.accessToken = reader.string();
                    break;
                case /* string conversation_id */ 2:
                    message.conversationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JoinConversationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string access_token = 1; */
        if (message.accessToken !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.accessToken);
        /* string conversation_id = 2; */
        if (message.conversationId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.conversationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.JoinConversationMessage
 */
export const JoinConversationMessage = new JoinConversationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LeaveConversationMessage$Type extends MessageType<LeaveConversationMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.LeaveConversationMessage", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<LeaveConversationMessage>): LeaveConversationMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        if (value !== undefined)
            reflectionMergePartial<LeaveConversationMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: LeaveConversationMessage): LeaveConversationMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: LeaveConversationMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.LeaveConversationMessage
 */
export const LeaveConversationMessage = new LeaveConversationMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ChatMessage$Type extends MessageType<ChatMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ChatMessage", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "payload", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<ChatMessage>): ChatMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        message.payload = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<ChatMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ChatMessage): ChatMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* bytes payload */ 2:
                    message.payload = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ChatMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* bytes payload = 2; */
        if (message.payload.length)
            writer.tag(2, WireType.LengthDelimited).bytes(message.payload);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ChatMessage
 */
export const ChatMessage = new ChatMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AuthAck$Type extends MessageType<AuthAck> {
    constructor() {
        super("c1.api.websocketnotify.v1.AuthAck", []);
    }
    create(value?: PartialMessage<AuthAck>): AuthAck {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AuthAck>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AuthAck): AuthAck {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AuthAck, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.AuthAck
 */
export const AuthAck = new AuthAck$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ErrorMessage$Type extends MessageType<ErrorMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ErrorMessage", [
            { no: 1, name: "code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ErrorMessage>): ErrorMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.code = "";
        message.message = "";
        if (value !== undefined)
            reflectionMergePartial<ErrorMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ErrorMessage): ErrorMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string code */ 1:
                    message.code = reader.string();
                    break;
                case /* string message */ 2:
                    message.message = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ErrorMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string code = 1; */
        if (message.code !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* string message = 2; */
        if (message.message !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.message);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ErrorMessage
 */
export const ErrorMessage = new ErrorMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ClientMessage$Type extends MessageType<ClientMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ClientMessage", [
            { no: 1, name: "auth", kind: "message", oneof: "message", T: () => AuthMessage },
            { no: 2, name: "subscribe", kind: "message", oneof: "message", T: () => SubscribeMessage },
            { no: 3, name: "join_conversation", kind: "message", oneof: "message", T: () => JoinConversationMessage },
            { no: 4, name: "leave_conversation", kind: "message", oneof: "message", T: () => LeaveConversationMessage }
        ]);
    }
    create(value?: PartialMessage<ClientMessage>): ClientMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ClientMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ClientMessage): ClientMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.websocketnotify.v1.AuthMessage auth */ 1:
                    message.message = {
                        oneofKind: "auth",
                        auth: AuthMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).auth)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.SubscribeMessage subscribe */ 2:
                    message.message = {
                        oneofKind: "subscribe",
                        subscribe: SubscribeMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).subscribe)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.JoinConversationMessage join_conversation */ 3:
                    message.message = {
                        oneofKind: "joinConversation",
                        joinConversation: JoinConversationMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).joinConversation)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.LeaveConversationMessage leave_conversation */ 4:
                    message.message = {
                        oneofKind: "leaveConversation",
                        leaveConversation: LeaveConversationMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).leaveConversation)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ClientMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.websocketnotify.v1.AuthMessage auth = 1; */
        if (message.message.oneofKind === "auth")
            AuthMessage.internalBinaryWrite(message.message.auth, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.SubscribeMessage subscribe = 2; */
        if (message.message.oneofKind === "subscribe")
            SubscribeMessage.internalBinaryWrite(message.message.subscribe, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.JoinConversationMessage join_conversation = 3; */
        if (message.message.oneofKind === "joinConversation")
            JoinConversationMessage.internalBinaryWrite(message.message.joinConversation, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.LeaveConversationMessage leave_conversation = 4; */
        if (message.message.oneofKind === "leaveConversation")
            LeaveConversationMessage.internalBinaryWrite(message.message.leaveConversation, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ClientMessage
 */
export const ClientMessage = new ClientMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ServerMessage$Type extends MessageType<ServerMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.ServerMessage", [
            { no: 1, name: "changed_ref", kind: "message", oneof: "message", T: () => ChangedRef },
            { no: 2, name: "chat_message", kind: "message", oneof: "message", T: () => ChatMessage },
            { no: 3, name: "auth_ack", kind: "message", oneof: "message", T: () => AuthAck },
            { no: 4, name: "error", kind: "message", oneof: "message", T: () => ErrorMessage },
            { no: 5, name: "a2ui_surface", kind: "message", jsonName: "a2uiSurface", oneof: "message", T: () => A2UISurfaceMessage }
        ]);
    }
    create(value?: PartialMessage<ServerMessage>): ServerMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.message = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<ServerMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ServerMessage): ServerMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.websocketnotify.v1.ChangedRef changed_ref */ 1:
                    message.message = {
                        oneofKind: "changedRef",
                        changedRef: ChangedRef.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).changedRef)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.ChatMessage chat_message */ 2:
                    message.message = {
                        oneofKind: "chatMessage",
                        chatMessage: ChatMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).chatMessage)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.AuthAck auth_ack */ 3:
                    message.message = {
                        oneofKind: "authAck",
                        authAck: AuthAck.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).authAck)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.ErrorMessage error */ 4:
                    message.message = {
                        oneofKind: "error",
                        error: ErrorMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).error)
                    };
                    break;
                case /* c1.api.websocketnotify.v1.A2UISurfaceMessage a2ui_surface */ 5:
                    message.message = {
                        oneofKind: "a2UiSurface",
                        a2UiSurface: A2UISurfaceMessage.internalBinaryRead(reader, reader.uint32(), options, (message.message as any).a2UiSurface)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ServerMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.websocketnotify.v1.ChangedRef changed_ref = 1; */
        if (message.message.oneofKind === "changedRef")
            ChangedRef.internalBinaryWrite(message.message.changedRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.ChatMessage chat_message = 2; */
        if (message.message.oneofKind === "chatMessage")
            ChatMessage.internalBinaryWrite(message.message.chatMessage, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.AuthAck auth_ack = 3; */
        if (message.message.oneofKind === "authAck")
            AuthAck.internalBinaryWrite(message.message.authAck, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.ErrorMessage error = 4; */
        if (message.message.oneofKind === "error")
            ErrorMessage.internalBinaryWrite(message.message.error, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.websocketnotify.v1.A2UISurfaceMessage a2ui_surface = 5; */
        if (message.message.oneofKind === "a2UiSurface")
            A2UISurfaceMessage.internalBinaryWrite(message.message.a2UiSurface, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.ServerMessage
 */
export const ServerMessage = new ServerMessage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class A2UISurfaceMessage$Type extends MessageType<A2UISurfaceMessage> {
    constructor() {
        super("c1.api.websocketnotify.v1.A2UISurfaceMessage", [
            { no: 1, name: "conversation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "envelope", kind: "message", T: () => A2UIEnvelope }
        ]);
    }
    create(value?: PartialMessage<A2UISurfaceMessage>): A2UISurfaceMessage {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.conversationId = "";
        if (value !== undefined)
            reflectionMergePartial<A2UISurfaceMessage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: A2UISurfaceMessage): A2UISurfaceMessage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string conversation_id */ 1:
                    message.conversationId = reader.string();
                    break;
                case /* c1.api.a2ui.v1.A2UIEnvelope envelope */ 2:
                    message.envelope = A2UIEnvelope.internalBinaryRead(reader, reader.uint32(), options, message.envelope);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: A2UISurfaceMessage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string conversation_id = 1; */
        if (message.conversationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.conversationId);
        /* c1.api.a2ui.v1.A2UIEnvelope envelope = 2; */
        if (message.envelope)
            A2UIEnvelope.internalBinaryWrite(message.envelope, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.websocketnotify.v1.A2UISurfaceMessage
 */
export const A2UISurfaceMessage = new A2UISurfaceMessage$Type();
